import React from "react";
import Select from "react-select";

import RevenueDistributionDrilldownPieChart from "./revenue-distribution-drilldown-pie-chart";

const DISTRIBUTION_TYPE = {
  GARD: "GOOGLE_AD_REVENUE_DISTRIBTUTION",
  NIRDL: "NET_INCREASED_REVENUE_DISTRIBUTION",
};

class RevenueDistributionSection extends React.Component {
  constructor(props) {
    super(props);

    const options = [
      {
        value: DISTRIBUTION_TYPE.GARD,
        label: "Ad Revenue Distribution",
      },
      {
        value: DISTRIBUTION_TYPE.NIRDL,
        label: "Net Increased Revenue Distribution",
      },
    ];
    const selectedValue = options[0];

    this.state = {
      options,
      selectedValue,

      isRequestTypeDimension: true,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleDimensionChange = this.handleDimensionChange.bind(this);
  }

  handleChange(option) {
    this.setState({
      selectedValue: option,
    });
  }

  handleDimensionChange(value) {
    this.setState({
      isRequestTypeDimension: value,
    });
  }

  render() {
    const { options, selectedValue, isRequestTypeDimension } = this.state;
    const {
      distributionData,
      selectedPubId,
      selectedNetworkId,
      selectedYieldSetIds,
      selectedRequestType,
      startDate,
      endDate,
      selectedCurrency,
    } = this.props;

    const parsedMetricKey =
      selectedValue.value === DISTRIBUTION_TYPE.GARD
        ? "googleAdRevenue"
        : "netIncreasedRevenue";

    const dimensionOptions = [
      {
        value: true,
        label: "Request Type",
      },
      {
        value: false,
        label: `${selectedNetworkId === -1 ? "Networks" : "Yield Sets"}`,
      },
    ];

    return (
      <React.Fragment>
        {/* <div className="font-semibold text-lg text-gray-800 mb-4 text-center">
          Revenue Distribution
        </div> */}

        <div className="mb-2">
          <ul className="nav">
            {dimensionOptions.map((opt) => {
              const isActive = opt.value === isRequestTypeDimension;

              const tabStyle = {
                cursor: "pointer",
                color: isActive ? "#1a202c" : "#333333",
                border: "1px solid #D1D5DB",
                marginRight: "8px",
                padding: "4px 8px",
                borderRadius: "4px",
                backgroundColor: isActive ? "#dae0e5" : "transparent",
              };

              return (
                <li className="nav-item" key={opt.label}>
                  <div
                    className={`nav-link ${isActive && "active"}`}
                    style={tabStyle}
                    onClick={() => this.handleDimensionChange(opt.value)}
                  >
                    {opt.label}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>

        <Select
          defaultValue={selectedValue}
          value={selectedValue}
          onChange={this.handleChange}
          options={options}
          isSearchable={false}
        />

        <div>
          <RevenueDistributionDrilldownPieChart
            reports={distributionData}
            metricKey={parsedMetricKey}
            selectedPubId={selectedPubId}
            selectedNetworkId={selectedNetworkId}
            selectedYieldSetIds={selectedYieldSetIds}
            selectedCurrency={selectedCurrency}
            selectedRequestType={selectedRequestType}
            isRequestTypeDimension={isRequestTypeDimension}
            startDate={startDate}
            endDate={endDate}
          ></RevenueDistributionDrilldownPieChart>
        </div>
      </React.Fragment>
    );
  }
}

export default RevenueDistributionSection;
